import React from 'react';
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import type { ConnectedRepository } from '../../types/dashboard';

export const StatusBadge: React.FC<{ status?: ConnectedRepository['status'] }> = ({ status }) => {
  if (!status) {
    return null;
  }

  const statusConfig = {
    healthy: {
      icon: CheckCircle,
      color: 'text-green-500',
      bg: 'bg-green-50 dark:bg-green-900/20',
      text: 'Healthy',
    },
    analyzing: {
      icon: Loader2,
      color: 'text-blue-500',
      bg: 'bg-blue-50 dark:bg-blue-900/20',
      text: 'Analyzing',
    },
    issues: {
      icon: AlertCircle,
      color: 'text-yellow-500',
      bg: 'bg-yellow-50 dark:bg-yellow-900/20',
      text: 'Maintenance Identified',
    },
    error: {
      icon: AlertCircle,
      color: 'text-gray-400',
      bg: 'bg-gray-50 dark:bg-gray-800/50',
      text: 'Analysis did not complete',
    },
  };

  const config = statusConfig[status];

  if (!config) {
    return null;
  }

  const Icon = config.icon;

  return (
    <div
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${config.bg} ${config.color}`}
    >
      <Icon className={`w-3 h-3 ${status === 'analyzing' ? 'animate-spin' : ''}`} />
      {config.text}
    </div>
  );
};
